module.exports = "<form #form=\"ngForm\">\r\n  <spk-card [class]=\"'col-md-5'\" meta=\"{{ getActionText() }} Application Setting\" title=\"{{model.Name}}\" [divider]=\"true\">\r\n    <spk-textarea name=\"Value\" [(model)]=\"model.Value\" [rows]=\"12\" [maxlength]=\"8000\"></spk-textarea>\r\n  </spk-card>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/application-settings/application-setting/application-setting.component.html
// module id = ./src/app/components/framework/application-settings/application-setting/application-setting.component.html
// module chunks = main